import { render, staticRenderFns } from "./530.vue?vue&type=template&id=10e8794a&scoped=true"
import script from "./530.vue?vue&type=script&lang=js"
export * from "./530.vue?vue&type=script&lang=js"
import style0 from "./530.vue?vue&type=style&index=0&id=10e8794a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e8794a",
  null
  
)

export default component.exports